let productSlider = null;
let quickShopSlider = null;

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 class Dropdown {
  constructor(element) {
    this.element = element;
    this.dropdownParent = element.parentElement;
    this.supportedEvents = ["mouseover", "focusin", "click", "mouseout", "touchstart"];
    this.init();
  }

  init() {
    this.supportedEvents.forEach((type) => {
      if (type === 'click') {
        this.element.addEventListener(type, (evt) => {
          evt.stopPropagation();
          this.handleDropdownEvent(evt);
        });
      } else if (type === 'mouseout' || type === 'touchstart') {
        this.dropdownParent.addEventListener(type, (evt) => {
          let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
          if (!mobileContainer) {
            this.dropdownHide(this.dropdownParent, evt.type);
          }
        }, true);
      } else if (type === 'mouseover' || type === 'focusin') {
        this.dropdownParent.addEventListener(type, (evt) => {
          let mobileContainer = evt.currentTarget.closest('[data-touch-moveable]');
          if (!mobileContainer) {
            this.dropdownShow(this.dropdownParent);
          }
        });
        this.element.addEventListener(type, (_evt) => {
          this.childOnFocusChange(this.dropdownParent);
        });
      }
    });

    this.bindEvents();
  }

  bindEvents(){
    let closeBtn = this.dropdownParent.querySelector('.close-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        let parentElement = evt.currentTarget.closest('.dropdown');
        if (parentElement) this.dropdownToggle(parentElement);
      });
    }
  }

  handleDropdownEvent(evt) {
    /* let currentTarget = evt.currentTarget;
    let liveTarget = evt.target;
    if (liveTarget.classList.contains('nav-link-title')) {
      let linkHref = currentTarget.getAttribute('data-href');
      if (linkHref) window.location.href = linkHref;
    } else {*/
      this.dropdownToggle(this.dropdownParent);
    /* } */
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    
    this.element.setAttribute('aria-expanded', true);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
      dropdownParent.classList.add('open');
      if(dropdownParent.closest('header') != null)
        document.querySelector('.desktop-navbar').classList.add('menu-open');
    } else {
      Utility.toggleElement(dropdownParent, 'open');
    }
  }

  dropdownHide(dropdownParent, eventType) {
    if (!dropdownParent) {
      return;
    }
   
    this.element.setAttribute('aria-expanded', false);
    if (!dropdownParent.closest('[data-role="drawer"]')) {
      dropdownParent.classList.remove('open');
      if(dropdownParent.closest('header') != null)
        document.querySelector('.desktop-navbar').classList.remove('menu-open');
    } else {
      Utility.toggleElement(dropdownParent, 'close');
    }

    if (eventType === 'mouseout' && dropdownParent.parentElement.closest('.dropdown')) {
      dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
    }

    let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        if (child.querySelector('a[data-toggle="open"]'))
          child.querySelector('a[data-toggle="open"]').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
 class DefaultNavItem {
  constructor(element) {
    this.element = element;
    this.supportedEvents = ["mouseover", "focusin", "click", "mouseout", "touchstart"];
    this.init();
  }

  init() {
    let _this = this.element;
    this.supportedEvents.forEach((type) => {
      _this.addEventListener(type, (e) => {
        e.stopPropagation();
        let currentTarget = e.currentTarget;
        if (!currentTarget.closest('[data-touch-moveable]')) {
          this.hideDropdown(currentTarget.parentElement);
        }
      });
    });

    _this.addEventListener('touchend', (e) => {
      e.stopPropagation();
    });
  }

  hideDropdown(dropdownParent) {
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
      ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
    });
  }
}
const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach((ele) => {
  new DefaultNavItem(ele);
});

/**
* background Overlay
*/
class siteOverlay extends HTMLElement{
  constructor() {
    super();

    this.menuDrawer = document.querySelector('#mobile-menu-drawer');
    this.cartDrawer = document.querySelector('#ajax-cart');
    this.searchDrawer = document.querySelector('search-modal');

    this.bindEvents();
  }

  connectedCallback() {
    
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event){
    const closeCart = this.cartDrawer && this.cartDrawer.classList.contains("opened-drawer");
    const closeMenu = this.menuDrawer && this.menuDrawer.classList.contains("opened-drawer");
    const closeSearch = this.searchDrawer && this.searchDrawer.classList.contains("open__modal");

    if(closeCart) document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    if(closeMenu) document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
    if(closeSearch) document.querySelector('.search-modal__close-button').dispatchEvent(new Event('click'));
  
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.querySelector('#site-overlay').classList.add('overlay--body');
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay 
   */
  hideOverlay(){
    const siteOv = document.querySelector('#site-overlay');
    if (siteOv) siteOv.classList.remove('overlay--body');
    const welcomeKitModal = document.querySelector('#welcome-kit');
    if (welcomeKitModal && welcomeKitModal.classList.contains('d-block')) {
      welcomeKitModal.classList.remove('d-block');
    }
    if (document.documentElement.classList.contains('welcome-kit-scroll-lock')) {
      unlockWelcomeKitScroll();
    } else {
      document.body.classList.remove('scroll-fixed');
    }
  }
}
customElements.define("site-overlay", siteOverlay, {
  once: true
});

/**
 * Slider Component
 *
 */
 class sliderElement extends HTMLElement{
  constructor() {
    super();
    this.sliderEle = this.querySelector('.swiper-slider');
    this.sliderOptions = JSON.parse(this.sliderEle.getAttribute('data-slider'));
  }

  static get observedAttributes() {
    return ["data-slider"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-slider" && newValue) {
      this.sliderOptions = JSON.parse(newValue);
    }
  }

  connectedCallback() {
    if(!this.sliderEle) return;
    
    let thumbSlider = null;

    // Set up nav slider 
    if(this.sliderEle.hasAttribute('data-nav')){
      thumbSlider = document.querySelector(`.${this.sliderEle.getAttribute('data-nav')}`);
      if(!thumbSlider){
        return;
      }

      const thumbSliderOptions = JSON.parse(thumbSlider.getAttribute('data-slider'));
      thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);
      
      this.sliderOptions.thumbs = {
        swiper: thumbSlider
      }
    }

    const sliderInstance = new Swiper(this.sliderEle, this.sliderOptions);

    if(this.sliderEle.classList.contains('product-carousel')){
      productSlider = sliderInstance;
      document.dispatchEvent(new Event('pdp:slider:ready'));

      // Handle initial image display for all products (single-variant and multi-variant)
      this.handleInitialImageDisplay(sliderInstance);

      // Signal the skeleton overlay to fade out — wait one paint frame so the
      // correct slide is fully rendered before .loader-ready triggers the transition.
      requestAnimationFrame(() => {
        const gallery = document.querySelector('.product-images-wrapper');
        if (gallery) gallery.classList.add('loader-ready');
      });
    }else if(this.sliderEle.classList.contains('quickshop-slider')){
      quickShopSlider = sliderInstance;
    }

    this.slideChangeEvt(sliderInstance, thumbSlider);
  }

  /**
   * Handle initial image display for all products (single-variant and multi-variant)
   */
      handleInitialImageDisplay(sliderInstance) {
        // When the section has disabled variant-based image navigation, stay at slide 0
        if (this.hasAttribute('data-disable-variant-images')) return;

        // Get variant data from JSON
        const variantJsonScript = document.querySelector('[data-variantJSON]');
        const metafieldJsonScript = document.querySelector('[data-variantJSON-metafields]');
        
        if (variantJsonScript && metafieldJsonScript) {
          try {
            const variants = JSON.parse(variantJsonScript.textContent);
            const metafields = JSON.parse(metafieldJsonScript.textContent);
            
            // Get the correct variant from URL or default to first variant
            if (variants.length > 0) {
              let currentVariant = variants[0]; // Default to first variant
              
              // Check if there's a variant in the URL
              const urlParams = new URLSearchParams(window.location.search);
              const urlVariantId = urlParams.get('variant');
              
              if (urlVariantId) {
                // Find the variant that matches the URL
                const urlVariant = variants.find(v => v.id.toString() === urlVariantId);
                if (urlVariant) {
                  currentVariant = urlVariant;
                }
              }
              
              currentVariant.metafields = metafields[currentVariant.id];
              
              // Check if the variant has the use_second_image_for_primary metafield set to true.
              // Skip the slide-1 navigation when the PDP overlay is active (cert_logos / slide_benefits)
              // so the overlay on slide 0 is what customers see first.
              const hasOverlay = currentVariant.metafields &&
                ((currentVariant.metafields.cert_logos && currentVariant.metafields.cert_logos.length > 0) ||
                 (currentVariant.metafields.slide_benefits && currentVariant.metafields.slide_benefits.length > 0));

              if (!hasOverlay &&
                  currentVariant.metafields &&
                  currentVariant.metafields.use_second_image_for_primary === true &&
                  sliderInstance.slides &&
                  sliderInstance.slides.length > 1) {

                // Default to second image (index 1) for single-variant products
                sliderInstance.slideTo(1, 0);
              }
            }
          } catch (error) {
            console.error('[Product slider] Error parsing variant JSON', error);
          }
        }
      }

  slideChangeEvt(slider, thumbSlider){
    // Capture thumb visibility BEFORE Swiper's thumbs module updates on slideChange
    let prevThumbVisibleIndexes = [];
    slider.on('slideChangeTransitionStart', () => {
      if(thumbSlider){
        prevThumbVisibleIndexes = [...(thumbSlider.visibleSlidesIndexes || [])];
      }
    });

    slider.on('slideChange', (event) => {
      // Boundary-aware thumb strip scroll:
      // Only scroll the strip when landing on the first or last visible thumb.
      // If the target was off-screen, Swiper's thumbs module already handled it.
      if(thumbSlider && prevThumbVisibleIndexes.length > 0){
        const targetIndex = slider.realIndex;
        const wasVisible = prevThumbVisibleIndexes.includes(targetIndex);
        if(wasVisible){
          const firstVisible = Math.min(...prevThumbVisibleIndexes);
          const lastVisible = Math.max(...prevThumbVisibleIndexes);
          const totalThumbs = thumbSlider.slides ? thumbSlider.slides.length : 0;
          if(targetIndex === lastVisible && lastVisible < totalThumbs - 1){
            thumbSlider.slideTo(thumbSlider.activeIndex + 1);
          } else if(targetIndex === firstVisible && thumbSlider.activeIndex > 0){
            thumbSlider.slideTo(Math.max(0, thumbSlider.activeIndex - 1));
          }
        }
      }

      const activeVideos = slider.el.querySelectorAll(
        ".custom-video-container.playing--video"
      );

      if(activeVideos.length > 0){
        activeVideos.forEach((container)=>{
          let video = container.querySelector('custom-video');
          let videoType = video.getAttribute('data-video-type');
          let videoEle = video.querySelector('video') || video.querySelector('iframe');
          if(videoType == 'local'){
            videoEle.pause();
          }else if(videoType == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
      }
    });
  }
 }
 let lookForSwiper = setInterval(() => {
  if(typeof Swiper == 'function'){
    customElements.define('slider-element', sliderElement);
    clearInterval(lookForSwiper);
  }
}, 100);

// Safety net: if Swiper never loads (e.g. network error), clear the skeleton
// overlay after 3 s so the page never stays permanently blocked.
setTimeout(() => {
  const gallery = document.querySelector('.product-images-wrapper');
  if (gallery && !gallery.classList.contains('loader-ready')) {
    gallery.classList.add('loader-ready');
  }
}, 3000);

// PDP image slider tracking — polls for the Swiper instance regardless of which
// script initializes it, then pushes pdp_slider_view events to window.dataLayer.
(function() {
  if (!window.globalVariables || window.globalVariables.template !== 'product') return;

  function pdpSliderTrack(swiper) {
    var slide = swiper.slides[swiper.activeIndex];
    if (!slide) return;
    var img = slide.querySelector('img');
    var product = (window.globalVariables && window.globalVariables.product) || {};
    var totalSlides = Array.from(swiper.slides).filter(function(s) {
      return !s.classList.contains('swiper-slide-duplicate');
    }).length;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pdp_slider_view',
      slider_index: swiper.realIndex + 1,
      slider_image_title: (img && (img.alt || img.getAttribute('data-variant-title'))) || '',
      slider_media_id: slide.getAttribute('data-mediaid') || '',
      slider_variant_handle: slide.getAttribute('data-variant-handle') || null,
      slider_total_slides: totalSlides,
      product_id: product.id || null,
      product_title: product.title || null
    });
  }

  var pdpTrackDebounce;
  var pdpTrackStart = Date.now();
  var pdpTrackPoll = setInterval(function() {
    var el = document.querySelector('.product-carousel');
    if (!el || !el.swiper) {
      if (Date.now() - pdpTrackStart > 8000) clearInterval(pdpTrackPoll);
      return;
    }
    clearInterval(pdpTrackPoll);
    var swiper = el.swiper;
    pdpSliderTrack(swiper);
    swiper.on('slideChange', function() {
      clearTimeout(pdpTrackDebounce);
      pdpTrackDebounce = setTimeout(function() { pdpSliderTrack(swiper); }, 300);
    });
  }, 100);
})();

try{
  document.addEventListener('DOMContentLoaded', function() {
    const home_playvideo = document.querySelectorAll('[data-video-btn]');
    home_playvideo.forEach((ele) => {
      ele.addEventListener('click', (event) => {
        // Toggle mute/unmute directly
        const videoParent = ele.closest('[data-video-parent]');
        if (!videoParent) return;
        
        let videoEle = videoParent.querySelector('video')
        document.querySelectorAll('[data-video-parent]').forEach((element)=>{
          if (videoEle != element.querySelector('video')) {
            element.classList.remove('video-play');
            // element.querySelector('video').muted = true;
          }
        })
        if (videoEle) {
          if(videoEle.muted){
            videoEle.muted = false;
            videoParent.classList.add('video-play');
          }else{
            videoEle.muted = true;
            videoParent.classList.remove('video-play');
          }
        }
      });
    });
  
    // collection list section
    const allMatchDiv = document.querySelectorAll('[data-height-match]');
    allMatchDiv.forEach(matchDiv => {
        const targetHeight = matchDiv.querySelector('[data-height-get]')?.offsetHeight;
        if (targetHeight) {
          matchDiv.style.setProperty('--bs-contnt-height', targetHeight + 'px');
        }
    });
  });
}catch(err){
  Utility._rollBar(err)
}

/**
* Custom Video
*/
class customVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.container.querySelectorAll('[data-trigger-video]');

    this.bindEvents();
  }

  connectedCallback() {
    // Connected callback
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) {
      this.triggerVideo.forEach(videoBtn => videoBtn.addEventListener('click', this.toggleView.bind(this)));
    }
    // Click anywhere on the poster/video body to play (when not already playing).
    // [data-trigger-video] button handles its own click, so skip those to avoid
    // double-firing. The full-screen cta-btn overlay handles click-to-pause while
    // playing, so this listener is only needed for the not-playing state.
    if (this.container) {
      this.container.addEventListener('click', (e) => {
        if (e.target.closest('[data-trigger-video]')) return;
        if (this.container.classList.contains('playing--video') && this.placementType === 'inline') {
          const v = this.videoSection.querySelector('video');
          if (v) v.pause();
          return;
        }
        if (!this.container.classList.contains('playing--video')) {
          this.toggleView(e);
        }
      });
    }
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(_event){
    let isOpen = this.container.classList.contains('playing--video');
    
    if(isOpen){
      if (this.placementType === 'inline') {
        const v = this.videoSection.querySelector('video');
        if (v) v.pause();
        return;
      }
      this.container.classList.remove('playing--video');
    }else{
      if(this.closest('.video-block-slider') != null){
        this.closest('.video-block-slider').querySelectorAll('.custom-video-container').forEach(x => x.classList.remove('playing--video'));
      }
      if(this.videoStatus == 'empty' || this.placementType == 'popup'){
        const videoElement = this._buildVideo();
        videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);;
        this.videoSection.appendChild(videoElement);
        this.videoStatus = 'loaded';

        // Ambient blur backdrop for product-slider videos: inject a blurred copy of
        // the poster thumbnail behind the playing video (same effect as poster state).
        if (this.container.closest('.product--media')) {
          const posterImg = this.querySelector('.poster-image .poster-fg');
          if (posterImg) {
            const blurBg = document.createElement('img');
            blurBg.src = posterImg.currentSrc || posterImg.src;
            blurBg.className = 'video-blur-bg';
            blurBg.setAttribute('aria-hidden', 'true');
            blurBg.alt = '';
            this.videoSection.insertBefore(blurBg, videoElement);
          }
        }

        // Sync playing--video class with native video pause/play so the
        // play button reappears when the video is paused via native controls.
        if (this.type === 'local') {
          videoElement.addEventListener('pause', () => this.container.classList.remove('playing--video'));
          videoElement.addEventListener('play',  () => this.container.classList.add('playing--video'));
        }

        // Inline mode: click anywhere on the video to pause (stopPropagation
        // prevents the container click listener from re-triggering play).
        if (this.placementType === 'inline' && this.type === 'local') {
          videoElement.addEventListener('click', (e) => {
            e.stopPropagation();
            videoElement.pause();
          });
        }

        setTimeout(() => {
          (this.placementType == 'popup') ? openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
          this.pauseOnVisibilityChange(videoElement);
          this._playVideo(videoElement);
        }, this.placementType === 'inline' ? 0 : 700);        
      }else{
        const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
        this.container.classList.add('playing--video');
        this._playVideo(videoElement);
      }
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;
    
    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true' && this.placementType !== 'inline') video.controls = true;
      if(this.dataset.muted == 'true') video.muted = true;
      if(this.dataset.autoplay == 'true') video.autoplay = true;
      video.loop = (this.dataset.loop === 'true');
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      let videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", "https://www.youtube.com/embed/"+ videoID +`?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&muted=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}` );
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    let scrollObserver = new IntersectionObserver((entries) => { 
      if((this.type == 'local' && videoEle == undefined) || (this.type == 'youtube' && videoEle.contentWindow == null)){
        scrollObserver.disconnect();
        return;
      }

      entries.forEach(entry => {
        if(entry.intersectionRatio == 0){
          if(this.type == 'local'){
            videoEle.pause();
          }else if(this.type == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      });
    });
    scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    let posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo || posterVideo == undefined) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          let sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();         
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }
}
customElements.define("custom-video", customVideo);

/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if(this.closeBtn){
      this.closeBtn.addEventListener(
        'click',
        this.hide.bind(this)
      );
    }

    this.addEventListener('click', (evt) => {
      if (evt.target.nodeName === 'MODAL-DIALOG') this.hide();
      if (evt.target === this.modal && this.hasAttribute('data-close-on-backdrop')) this.hide();
    });

    this._handleKeydown = (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') {
        event.preventDefault();
        this.hide();
      }
    };
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    document.addEventListener('keydown', this._handleKeydown);
    this.openedBy = opener;
    this.modal.classList.add('open');
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    siteOverlay.prototype.hideOverlay();
    document.removeEventListener('keydown', this._handleKeydown);

    if(this.id == 'PopupModal-video'){
      this.querySelector('.video-container').innerHTML = '';
    }
    
    Utility.removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class Notification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  /**
   * Notification Type
   * @param title 
   * @param body 
   * @param options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    cancelAnimationFrame(this.animateNotifcation);
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", Notification);
window.notificationEle = document.querySelector('toast-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });


  document.addEventListener("DOMContentLoaded", function () {
    class ImageCompare extends HTMLElement {
      constructor() {
        super();
        this.el = this;
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector("[data-button]");
        this.draggableContainer = this.querySelector("[data-draggable]");
        this.primaryImage = this.querySelector("[data-primary-image]");
        this.secondaryImage = this.querySelector("[data-secondary-image]");
  
        if (!this.button || !this.draggableContainer || !this.primaryImage) {
          console.warn('[ImageCompare] Missing required elements (button, draggableContainer, or primaryImage)');
          return;
        }
  
        this.active = false;
        this.currentX = 0;
        this.initialX = 0;
        this.xOffset = 0;
        this.elWidth = 0;
        this.buttonOffset = this.button.offsetWidth / 2;
  
        this.calculateSizes();
  
        // Bind event listeners
        this.dragStart = this.dragStart.bind(this);
        this.dragEnd = this.dragEnd.bind(this);
        this.drag = this.drag.bind(this);
  
        this.el.addEventListener("touchstart", this.dragStart, false);
        this.el.addEventListener("touchend", this.dragEnd, false);
        this.el.addEventListener("touchmove", this.drag, false);
  
        this.el.addEventListener("mousedown", this.dragStart, false);
        this.el.addEventListener("mouseup", this.dragEnd, false);
        this.el.addEventListener("mousemove", this.drag, false);
  
        // Handle resize
        window.addEventListener(
          "resize",
          debounce(() => this.calculateSizes(true), 250)
        );
  
        // Handle Shopify Section Reload
        document.addEventListener("shopify:section:load", (event) => {
          if (event.detail.sectionId === this.sectionId) {
            this.calculateSizes();
          }
        });
      }
  
      calculateSizes(hasResized = false) {
        this.active = false;
        this.currentX = 0;
        this.initialX = 0;
        this.xOffset = 0;
  
        this.elWidth = this.el.offsetWidth;
        this.buttonOffset = this.button.offsetWidth / 2;
       
        this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;
  
        if (this.primaryImage) {
          this.primaryImage.style.width = `${this.elWidth}px`;
        }

        if (hasResized) {
          this.draggableContainer.style.width = `${this.elWidth * 0.8}px`;
        }
      }
  
      dragStart(e) {
        e.preventDefault();
        if (e.type === "touchstart") {
          this.initialX = e.touches[0].clientX - this.xOffset;
        } else {
          this.initialX = e.clientX - this.xOffset;
        }
  
        if (e.target === this.button) {
          this.active = true;
        }
      }
  
      dragEnd() {
        this.initialX = this.currentX;
        this.active = false;
      }
  
      drag(e) {
        if (!this.active) return;
  
        e.preventDefault();
  
        if (e.type === "touchmove") {
          this.currentX = e.touches[0].clientX - this.initialX;
        } else {
          this.currentX = e.clientX - this.initialX;
        }
  
        this.xOffset = this.currentX;
        this.setTranslate(this.currentX, this.button);
      }
  
      setTranslate(xPos, el) {
        let newXpos = xPos - this.buttonOffset;
        let newVal = this.elWidth * 0.8 + xPos;
  
        const boundaryPadding = 50;
        const XposMin = (this.elWidth * 0.8 + this.buttonOffset) * -1;
        const XposMax = this.elWidth - this.buttonOffset;
  
        // Set boundaries for dragging
        if (newXpos < XposMin + boundaryPadding) {
          newXpos = XposMin + boundaryPadding;
          newVal = boundaryPadding;
        } else if (newXpos > XposMax - boundaryPadding) {
          newXpos = XposMax - boundaryPadding;
          newVal = this.elWidth - boundaryPadding;
        }
  
        el.style.transform = `translate(${newXpos}px, -50%)`;
        this.draggableContainer.style.width = `${newVal}px`;
      }
    }
  
    customElements.define("image-compare", ImageCompare);
  
    // Debounce Function to Improve Performance
    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  });

  document.querySelectorAll(".block__article-url-copy").forEach(element => {
      element.addEventListener("click", copyarticleurl);
  });

  function copyarticleurl(event) {
      navigator.clipboard.writeText(event.currentTarget.getAttribute("data-href"));
      window.notificationEle.updateNotification('Link copied', "", {
        type: 'success',
        timeout: 5000
      });
  }

  // Get the modal
var modal = document.getElementById("PopupModal-image");

// Get the image and insert it inside the modal - use its "alt" text as a caption
var img = document.getElementById("bubs_ingredients_image");
if(img != null){
  var modalImg = document.getElementById("imagecontainer");
  img.onclick = function(){
    this.openedBy = opener;
    modal.classList.add('open');
    modalImg.src = this.querySelector("img").getAttribute('data-src');
    
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
    document.querySelector("site-overlay").classList.remove('overlay--body');
    document.querySelector("body").classList.remove("scroll-fixed");
  }
}

/**
 * Welcome kit: block background scrolling without body position:fixed (no jump, no scrollTo).
 */
function lockWelcomeKitScroll() {
  const sbw = window.innerWidth - document.documentElement.clientWidth;
  if (sbw > 0) {
    document.body.style.paddingRight = `${sbw}px`;
  }
  document.documentElement.classList.add("welcome-kit-scroll-lock");
}

function unlockWelcomeKitScroll() {
  document.documentElement.classList.remove("welcome-kit-scroll-lock");
  document.body.style.paddingRight = "";
}

// Welcome kit modal handler (delegated — works for any [data-welcome-kit], including full-card hit targets)
(function() {
  function attachWelcomeKitHandlers() {
    const closeButton = document.querySelector("#ModalClose-welcome-kit");

    if (!document.documentElement.hasAttribute("data-welcome-kit-delegation")) {
      document.documentElement.setAttribute("data-welcome-kit-delegation", "true");
      function openWelcomeKitModal(event) {
        if (event) event.preventDefault();
        const siteOverlay = document.querySelector("site-overlay");
        const welcomeKitModal = document.querySelector("#welcome-kit");
        if (siteOverlay) siteOverlay.classList.add("overlay--body");
        lockWelcomeKitScroll();
        if (welcomeKitModal) welcomeKitModal.classList.add("d-block");
      }
      document.body.addEventListener("click", function (event) {
        const trigger = event.target.closest("[data-welcome-kit]");
        if (!trigger) return;
        openWelcomeKitModal(event);
      });
      document.body.addEventListener("keydown", function (event) {
        if (event.key !== " " && event.key !== "Enter") return;
        const trigger =
          document.activeElement && document.activeElement.closest("[data-welcome-kit]");
        if (!trigger || document.activeElement !== trigger) return;
        openWelcomeKitModal(event);
      });
    }

    if (closeButton && !closeButton.hasAttribute('data-handler-attached')) {
      closeButton.setAttribute('data-handler-attached', 'true');
      closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        const siteOverlay = document.querySelector("site-overlay");
        const welcomeKitModal = document.querySelector("#welcome-kit");

        if (siteOverlay) siteOverlay.classList.remove("overlay--body");
        unlockWelcomeKitScroll();
        if (welcomeKitModal) welcomeKitModal.classList.remove("d-block");
      });
    }
  }
  
  // Try immediately and on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachWelcomeKitHandlers);
  } else {
    attachWelcomeKitHandlers();
  }
  
  // Watch for dynamically added elements
  new MutationObserver(attachWelcomeKitHandlers).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Recharge benefits image click handler (nested shadow DOM)
(function() {
  function findBenefitsImage() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget?.shadowRoot) return null;
    
    // Recursively search nested shadow DOMs
    function searchShadowRoot(root) {
      if (!root) return null;
      
      const image = root.querySelector('img[name="Benefits"][part="rc-benefits__image"]') ||
                    root.querySelector('img[name="Benefits"]') ||
                    root.querySelector('img[alt="Benefits"]') ||
                    Array.from(root.querySelectorAll('img')).find(img => 
                      img.src && img.src.includes('NTBlM2MxNmQ1MA')
                    );
      
      if (image) return image;
      
      // Check nested shadow DOMs
      const elements = root.querySelectorAll('*');
      for (const el of elements) {
        if (el.shadowRoot) {
          const nestedImage = searchShadowRoot(el.shadowRoot);
          if (nestedImage) return nestedImage;
        }
      }
      
      return null;
    }
    
    return searchShadowRoot(widget.shadowRoot);
  }
  
  function attachClickHandler() {
    const image = findBenefitsImage();
    if (image && !image.hasAttribute('data-click-handler-attached')) {
      image.setAttribute('data-click-handler-attached', 'true');
      image.style.cursor = 'pointer'; // Show it's clickable
      
      image.addEventListener('click', function(event) {
        event.preventDefault();
        const siteOverlay = document.querySelector("site-overlay");
        const welcomeKitModal = document.querySelector("#welcome-kit");
        if (siteOverlay) siteOverlay.classList.add("overlay--body");
        lockWelcomeKitScroll();
        if (welcomeKitModal) welcomeKitModal.classList.add("d-block");
      });
    }
  }
  
  // Try immediately and on intervals
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachClickHandler);
  } else {
    attachClickHandler();
  }
  
  // Poll for image
  setInterval(attachClickHandler, 500);
  
  // Watch for changes
  new MutationObserver(attachClickHandler).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Cart > upgrade to subscription > optgroup label : change to "Subscribe and Save"
function updateOptgroupLabels() {
  document.querySelectorAll("optgroup").forEach(optgroup => {
    let label = optgroup.getAttribute("label");
    if (label && label.startsWith("Subscribe and Save")) {
      // Always reset it to just "Subscribe and Save"
      optgroup.setAttribute("label", "Subscribe and Save");
    }
  });
}

// Run on DOM ready
document.addEventListener("DOMContentLoaded", updateOptgroupLabels);

// Watch for dynamically added elements (like Rebuy Smart Cart)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      // Check if any optgroup elements were added
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.tagName === 'OPTGROUP' || node.querySelector('optgroup')) {
            updateOptgroupLabels();
          }
        }
      });
    }
  });
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Custom JS to style the cookie policy link different
document.addEventListener("DOMContentLoaded", function () {
  const policyLink = document.getElementById("shopify-pc__banner__body-policy-link");
  const prefsBtn = document.getElementById("shopify-pc__banner__btn-manage-prefs");

  if (policyLink && prefsBtn) {
    // Make sure button is inline-block
    prefsBtn.style.display = "inline-block";

    // Build the sentence fragment: ", and your settings can be changed in our [button]."
    const prefixText = document.createTextNode(", and your settings can be changed in our ");
    const suffixText = document.createTextNode(".");

    // Insert everything in order after the Privacy Policy link
    policyLink.parentNode.insertBefore(prefixText, policyLink.nextSibling);
    policyLink.parentNode.insertBefore(prefsBtn, prefixText.nextSibling);
    policyLink.parentNode.insertBefore(suffixText, prefsBtn.nextSibling);
  }
});
